
export const utoa = (argStr: string) => {
    return btoa(unescape(encodeURIComponent(argStr)));
};

export const btou = (argStr: string) => {
    return decodeURIComponent(escape(atob(argStr)));
};

export const arraysAreEqual = (a: Array<string | number>, b: Array<string | number>) =>
    a.length === b.length &&
    !a.some(itemA => !b.find(itemB => itemB === itemA));

// Base 64 encode a string then modify it to be URL safe.
export const urlSafeBtoa = (str: string) =>
    btoa(str)
   .replace(/\+/g, "-")
   .replace(/\//g, "_")
   .replace(/=/g, "");

// Modifies the input string back to normal base64 and then decodes it.
export const urlSafeAtob = (b64_str: string) =>
    atob(
        b64_str.replace(/-/g, '+')
               .replace(/_/g, '/')
        + '='.repeat(b64_str.length % 4)
    );

export const encodeObject = (object: any): string =>
    urlSafeBtoa(JSON.stringify(object));

export const decodeObject = (b64_object: string): any =>
    JSON.parse(urlSafeAtob(b64_object));
